
import { useState, useEffect } from 'react';
import MobileAudienceView from './audience/MobileAudienceView';
import DesktopAudienceView from './audience/DesktopAudienceView';
import audienceData from '@/data/audienceData';

const AudienceSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    const handleScroll = () => {
      const element = document.getElementById('audience-section');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    
    handleResize(); // Check initial size
    handleScroll(); // Check initial position
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section id="audience-section" className="py-20">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className={`text-3xl md:text-4xl font-bold text-abbella-ebony mb-4 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-8'}`}>
            FlowCare for Every Need
          </h2>
          <p className={`text-lg text-slate-600 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-8'}`}>
            Tailored care solutions for a variety of healthcare needs
          </p>
        </div>
        
        {isMobile ? (
          <MobileAudienceView audiences={audienceData} isVisible={isVisible} />
        ) : (
          <DesktopAudienceView audiences={audienceData} isVisible={isVisible} />
        )}
      </div>
    </section>
  );
};

export default AudienceSection;
